<template>
  <div class="d-flex" :class="$vuetify.breakpoint.smAndUp ? 'flex-column' : 'flex-row mr-1 align-center'">
    <v-btn
      class="btn-get-code px-2"
      :class="$vuetify.breakpoint.smAndUp ? 'mb-1' : ''"      
      :disabled="activeVariables.length >= 5"
      title="افزودن ورودی جدید"
      @click="addNewVariable" 
    ><v-icon :color="activeVariables.length >= 5 ? 'grey' : 'success'">mdi-plus</v-icon>
    افزودن ورودی جدید

    </v-btn>
  </div>
</template>

<script>
export default {
  name: "VariablePicker",
  props: {
    textValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      menu: false
    };
  },
  computed: {
    activeVariables() {
      if (!this.textValue) return [];

      const matches = this.textValue.match(/data\d+/gi) || [];
      const uniqueVars = [...new Set(matches.map(v => v.toLowerCase()))];

      return uniqueVars.sort((a, b) => {
        const numA = parseInt(a.replace("data", ""), 10);
        const numB = parseInt(b.replace("data", ""), 10);
        return numA - numB;
      });
    }
  },
  methods: {
    addNewVariable() {
      // استخراج شماره‌های فعال موجود
      const usedNumbers = this.activeVariables.map(v =>
        parseInt(v.replace("data", ""), 10)
      );

      // یافتن اولین شماره آزاد بین ۱ تا ۵
      let nextNum = null;
      for (let i = 1; i <= 5; i++) {
        if (!usedNumbers.includes(i)) {
          nextNum = i;
          break;
        }
      }

      // درج ورودی در صورت وجود ظرفیت
      if (nextNum !== null) {
        const newVar = ` data${nextNum} `;
        this.$emit("insert", newVar);
      }
    },

    selectExistingVariable(varItem) {
      this.$emit("insert", ` ${varItem} `);
      this.menu = false;
    },

    removeVariable(varItem) {
      this.$emit("remove", varItem);

      if (this.activeVariables.length <= 1) {
        this.menu = false;
      }
    }
  }
};
</script>

<style scoped>
.glass-menu {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}

.transparent-card {
  background-color: transparent !important;
}

.chip-hover {
  cursor: pointer;
  transition: all 0.2s;
}

.chip-hover:hover {
  background-color: rgba(30, 136, 229, 0.05) !important;
}

.gap-1 {
  gap: 4px;
}
</style>
